import styled from 'styled-components';

import { StyledCard } from '@components/card';
import { theme } from '@styles/theme';

export const SourceCard = styled(StyledCard).attrs({
  'data-variant': 'default',
})({
  '--card-space': '1rem 1.5rem',
  '@media(max-width: 768px)': {
    '> div': {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
});

export const Line = styled.div({
  height: '2rem',
  width: '0.0625rem',
  flexShrink: 0,
  backgroundColor: theme.color.purple10,
});
